//Todo time list
export const USER_ID_TODO_TIME_REQUEST = "USER_ID_TODO_TIME_REQUEST";
export const USER_ID_TODO_TIME_SUCCESS = "USER_ID_TODO_TIME_SUCCESS";
export const USER_ID_TODO_TIME_FAIL = "USER_ID_TODO_TIME_FAIL";

//Todo Range time list
export const USER_ID_RANGE_TODO_TIME_REQUEST =
  "USER_ID_RANGE_TODO_TIME_REQUEST";
export const USER_ID_RANGE_TODO_TIME_SUCCESS =
  "USER_ID_RANGE_TODO_TIME_SUCCESS";
export const USER_ID_RANGE_TODO_TIME_FAIL = "USER_ID_RANGE_TODO_TIME_FAIL";

//Todo Monthly time list
export const USER_ID_MONTH_TODO_TIME_REQUEST =
  "USER_ID_MONTH_TODO_TIME_REQUEST";
export const USER_ID_MONTH_TODO_TIME_SUCCESS =
  "USER_ID_MONTH_TODO_TIME_SUCCESS";
export const USER_ID_MONTH_TODO_TIME_FAIL = "USER_ID_MONTH_TODO_TIME_FAIL";

//Todo list
export const USER_ID_TODO_REQUEST = "USER_ID_TODO_REQUEST";
export const USER_ID_TODO_SUCCESS = "USER_ID_TODO_SUCCESS";
export const USER_ID_TODO_FAIL = "USER_ID_TODO_FAIL";

//Todo All Complete list
export const USER_ID_ALL_COMPLETE_TODO_REQUEST =
  "USER_ID_ALL_COMPLETE_TODO_REQUEST";
export const USER_ID_ALL_COMPLETE_TODO_SUCCESS =
  "USER_ID_ALL_COMPLETE_TODO_SUCCESS";
export const USER_ID_ALL_COMPLETE_TODO_FAIL = "USER_ID_ALL_COMPLETE_TODO_FAIL";

//All Completed Todo List Of User
export const USER_ID_COMPLETE_ALL_TODO_REQUEST =
  "USER_ID_COMPLETE_ALL_TODO_REQUEST";
export const USER_ID_COMPLETE_ALL_TODO_SUCCESS =
  "USER_ID_COMPLETE_ALL_TODO_SUCCESS";
export const USER_ID_COMPLETE_ALL_TODO_FAIL = "USER_ID_COMPLETE_ALL_TODO_FAIL";

//All In Completed Todo List Of User
export const USER_ID_INCOMPLETE_ALL_TODO_REQUEST =
  "USER_ID_INCOMPLETE_ALL_TODO_REQUEST";
export const USER_ID_INCOMPLETE_ALL_TODO_SUCCESS =
  "USER_ID_INCOMPLETE_ALL_TODO_SUCCESS";
export const USER_ID_INCOMPLETE_ALL_TODO_FAIL =
  "USER_ID_INCOMPLETE_ALL_TODO_FAIL";

//All Completed Todo Time List Of User
export const USER_ID_ALL_TODO_TIME_REQUEST = "USER_ID_ALL_TODO_TIME_REQUEST";
export const USER_ID_ALL_TODO_TIME_SUCCESS = "USER_ID_ALL_TODO_TIME_SUCCESS";
export const USER_ID_ALL_TODO_TIME_FAIL = "USER_ID_ALL_TODO_TIME_FAIL";

//Todo All InComplete list
export const USER_ID_ALL_INCOMPLETE_TODO_REQUEST =
  "USER_ID_ALL_INCOMPLETE_TODO_REQUEST";
export const USER_ID_ALL_INCOMPLETE_TODO_SUCCESS =
  "USER_ID_ALL_INCOMPLETE_TODO_SUCCESS";
export const USER_ID_ALL_INCOMPLETE_TODO_FAIL =
  "USER_ID_ALL_INCOMPLETE_TODO_FAIL";

//Today's Complete Todo list
export const USER_ID_TODAY_COMPLETED_TODO_REQUEST =
  "USER_ID_TODAY_COMPLETED_TODO_REQUEST";
export const USER_ID_TODAY_COMPLETED_TODO_SUCCESS =
  "USER_ID_TODAY_COMPLETED_TODO_SUCCESS";
export const USER_ID_TODAY_COMPLETED_TODO_FAIL =
  "USER_ID_TODAY_COMPLETED_TODO_FAIL";

//Prev Completed Todo list
export const USER_ID_PREV_COMPLETED_TODO_REQUEST =
  "USER_ID_PREV_COMPLETED_TODO_REQUEST";
export const USER_ID_PREV_COMPLETED_TODO_SUCCESS =
  "USER_ID_PREV_COMPLETED_TODO_SUCCESS";
export const USER_ID_PREV_COMPLETED_TODO_FAIL =
  "USER_ID_PREV_COMPLETED_TODO_FAIL";
